import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

export default function SuccessScreen({ t }) {
  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      className="text-center py-12 px-4 flex flex-col items-center justify-center min-h-[60vh]"
    >
      <motion.div 
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
        className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mb-6 text-emerald-600 text-4xl"
      >
        <SafeIcon name="Check" />
      </motion.div>
      
      <h2 className="text-2xl font-bold text-gray-900 mb-4">{t.successTitle}</h2>
      <p className="text-gray-600 mb-6 max-w-md mx-auto leading-relaxed">
        {t.successMsg}
      </p>
      
      <div className="bg-emerald-50 border border-emerald-100 rounded-2xl p-6 max-w-md mx-auto text-left">
        <div className="flex gap-3 text-emerald-800">
          <SafeIcon name="Info" className="text-xl flex-shrink-0 mt-0.5" />
          <p className="text-sm font-medium leading-relaxed">
            {t.successDetails}
          </p>
        </div>
      </div>
    </motion.div>
  );
}